export class TrackerStatus {
  id: number;

  code: string;

  main: boolean;
}



// WEBPACK FOOTER //
// /builds/weenect1/backofficev3/src/app/entities/trackerstatus.entity.ts